import { render } from "./FloatBall.vue?vue&type=template&id=dd958fb8&scoped=true"
import script from "./FloatBall.vue?vue&type=script&lang=js"
export * from "./FloatBall.vue?vue&type=script&lang=js"

import "./FloatBall.vue?vue&type=style&index=0&id=dd958fb8&scoped=true&lang=css"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd958fb8"]])

export default __exports__